module.exports = __webpack_public_path__ + "img/crm_case5.4373dee8.png";